import { takeEvery, takeLatest } from 'redux-saga/effects';
import { affordabilitySaga } from './affordability-saga';
import { allBloodRelationshipsSaga } from './all-blood-relationships-saga';
import { bloodRelationshipsCheckSaga } from './bloodrelationships-check-saga';
import { countiesForZipcodeSaga } from './counties-for-zipcode-saga';
import { countriesSaga } from './countries-saga';
import { enrollmentsSaga } from './enrollments-saga';
import { initialBootstrapSaga } from './initial-bootstrap-saga';
import { previousSsapDataSaga } from './previous-ssap-data-saga';
import { receiveSsnsSaga } from './receive-ssns-saga';
import { saveSsapSaga } from './save-ssap-saga';
import { submitSsapSaga } from './submit-application-saga';
import { summaryToInboxSaga } from './summary-to-inbox-saga';
import { tribesSaga } from './tribes-saga';
import { validateAddressSaga } from './validate-address-saga';
import { ssapSagaActionTypes } from '../../constants/actionTypes/ssapActionTypes';

const {
    BLOOD_RELATIONSHIPS_CHECK,
    FETCH_AFFORDABILITY,
    FETCH_ALL_BLOOD_RELATIONSHIPS,
    FETCH_COUNTIES_FOR_ZIPCODE,
    FETCH_COUNTRIES,
    FETCH_ENROLLMENTS,
    FETCH_SSAP_DATA,
    FETCH_SSAP_PREVIOUS_DATA,
    FETCH_TRIBES,
    RECEIVE_SSNS,
    SAVE_SSAP,
    SEND_SUMMARY_TO_INBOX,
    SUBMIT_SSAP,
    VALIDATE_ADDRESS
} = ssapSagaActionTypes;

export default function* () {
    yield takeLatest(FETCH_AFFORDABILITY, affordabilitySaga);
    yield takeLatest(FETCH_ALL_BLOOD_RELATIONSHIPS, allBloodRelationshipsSaga);
    yield takeEvery(BLOOD_RELATIONSHIPS_CHECK, bloodRelationshipsCheckSaga);
    yield takeEvery(FETCH_COUNTIES_FOR_ZIPCODE, countiesForZipcodeSaga);
    yield takeLatest(FETCH_COUNTRIES, countriesSaga);
    yield takeLatest(FETCH_ENROLLMENTS, enrollmentsSaga);
    yield takeLatest(FETCH_SSAP_DATA, initialBootstrapSaga);
    yield takeLatest(FETCH_SSAP_PREVIOUS_DATA, previousSsapDataSaga);
    yield takeEvery(RECEIVE_SSNS, receiveSsnsSaga);
    yield takeEvery(SAVE_SSAP, saveSsapSaga);
    yield takeEvery(SUBMIT_SSAP, submitSsapSaga);
    yield takeLatest(SEND_SUMMARY_TO_INBOX, summaryToInboxSaga);
    yield takeLatest(FETCH_TRIBES, tribesSaga);
    yield takeEvery(VALIDATE_ADDRESS, validateAddressSaga);
}